import padding from './padding';
import margin from './margin';

export default [ margin, padding ];
